// Cercul din elementul de profil de sus (meniul pe calculator, bara elevului pe telefon): poza
// omului, dacă are una, altfel iconița rolului (coroana / cheia / toca). Urmărește și o poză
// schimbată acum în filă (rememberAvatarChange), ca să apară fără reîncărcare.
import React, { useSyncExternalStore } from "react";
import { ReactSVG } from "react-svg";

import { AvatarUI } from "../UI";
import { getAvatarChangeVersion, ownAvatarUrl, subscribeAvatarChanges } from "../../utils/userAvatar";

export default function HeaderStatusAvatar({ person, iconSrc }) {
   useSyncExternalStore(subscribeAvatarChanges, getAvatarChangeVersion, getAvatarChangeVersion);
   if (person && ownAvatarUrl(person)) {
      return <AvatarUI person={person} size={null} className="header__statut header__statut--photo" />;
   }
   return <ReactSVG className="header__statut" src={iconSrc} />;
}
